import { getLabelV2 } from '../../common/labelV2.js';

/**
 * Maps status customerImpact + severity to labelV2 message ids.
 *
 * - severity set + Most  → impact_scope_Most
 * - severity set + Some  → impact_scope_Some
 * - severity set + other → impact_scope_None
 * - severity not set (maintenance) → impact_scope_Medium
 *
 * @param {string|undefined} customerImpact
 * @param {{ severity?: string, type?: string }} [context]
 * @returns {string|undefined}
 */
export function impactScopeMessageId(customerImpact, context = {}) {
  const { severity, type } = context;

  if (type === 'maintenance') {
    return 'impact_scope_Medium';
  }

  const impact = customerImpact?.trim().toLowerCase();
  switch (impact) {
    case 'most':
      return 'impact_scope_Most';
    case 'some':
      return 'impact_scope_Some';
    default:
      return 'impact_scope_None';
  }
}

/**
 * @param {string|undefined} customerImpact
 * @param {{ severity?: string, type?: string }} [context]
 * @returns {string}
 */
export function getImpactScopeLabel(customerImpact, context = {}) {
  const messageId = impactScopeMessageId(customerImpact, context);
  return messageId ? getLabelV2(messageId) : '';
}
